module.exports = __webpack_public_path__ + "media/images/icons/brands/w3c-4650e9bd74b44c947f1b087aa01dcbc7.svg";